import React from "react";
import ReactDOM from "react-dom";
import SwiperCore, { Navigation, Keyboard } from "swiper/core";
import Swiper from "swiper";
import "swiper/swiper.min.css";
import imagesLoaded from "imagesloaded";

import { GalleryModal } from "components";
import { getRenderRoot, RenderRoot } from "utils";
import { IImage } from "types";

SwiperCore.use([Navigation, Keyboard]);

const galleryBlocks = document.querySelectorAll<HTMLElement>("[data-gallery]");
const MODAL_ROOT = getRenderRoot(RenderRoot.modal);

// init swiper gallery in content blocks
(() => {
  galleryBlocks.forEach((galleryBlock, index) => {
    const index1 = index + 1;
    const swiperClass = `swiper-container-${index1}`;
    const swiperPrevClass = "swiper-button-prev";
    const swiperNextClass = "swiper-button-next";

    // add unique class to swiper element
    // to allow multiple instances on one page
    // https://stackoverflow.com/questions/32118999/how-can-i-have-multiple-swiper-slideshows-on-a-single-page
    galleryBlock.classList.add(swiperClass);

    const element = document.querySelector<HTMLElement>(`.${swiperClass}`);
    if (!element) return;

    const swiperContainer = element.parentElement;
    if (!swiperContainer) return;

    // add unique class to swiper prev button
    swiperContainer
      .querySelector(`.${swiperPrevClass}`)
      ?.classList.add(`${swiperPrevClass}-${index1}`);

    // add unique class to swiper next button
    swiperContainer
      .querySelector(`.${swiperNextClass}`)
      ?.classList.add(`${swiperNextClass}-${index1}`);

    const swiper = new Swiper(element, {
      slidesPerView: "auto",
      spaceBetween: 16,
      preloadImages: true,
      updateOnImagesReady: true,
      updateOnWindowResize: true,
      navigation: {
        prevEl: `.${swiperPrevClass}-${index1}`,
        nextEl: `.${swiperNextClass}-${index1}`,
      },
    });

    swiper.navigation.init();

    // update swiper after all images are loaded
    imagesLoaded(element, () => {
      setTimeout(() => {
        swiper.update();
      }, 0);
    });
  });
})();

// init fullscreen swiper gallery
(() => {
  galleryBlocks.forEach((galleryBlock) => {
    const imageElements = galleryBlock.querySelectorAll<HTMLElement>(
      "[data-gallery-image]"
    );

    if (!imageElements) return;

    const images: IImage[] = Array.from(imageElements).map((slide) => {
      const data = slide.dataset.galleryImage;
      slide.dataset.galleryImage = ""; // cleanup

      if (!data) return undefined;

      return JSON.parse(data);
    });

    imageElements.forEach((imageElement, index) => {
      imageElement.addEventListener("click", () => {
        ReactDOM.render(
          <GalleryModal images={images} initIndex={index} />,
          MODAL_ROOT
        );
      });
    });
  });
})();
